export default __webpack_public_path__ + "static/media/PH-A527.4e54d62e.webp";